/* Sidebar used 1:1 like planung-frontend: the DS `Sidebar` styling is taken
 * as-is (rail width, nav-icon size, active state, logo position all DS default).
 * The only app override — mirrored from planung — forces the nav to fill height. */
.sidebar {
  nav[class*="module_main-nav"] {
    height: 100%;
    margin-bottom: 0;
  }

  /* Collapsed rail: the nav icons centre correctly, but the DS logo box sits
     ~9px right of the rail centre. Nudge only the collapsed logo back so it
     lines up with the nav icons. Scoped to the collapsed logo, so the expanded
     (icon + wordmark) logo is untouched. */
  [class*="logo-wrapper"]:has([class*="Logo-module_collapsed"]) {
    transform: translateX(-9px);
  }
}
